import React, { useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { Link, useHistory } from 'react-router-dom';
import { ApiService } from '../api/ApiService';
import { SettlementChecks } from '../api/model/SettlementChecks';
import { ChevronRight } from '../components/icons';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';

const Settlements: React.FC = () => {
    const history = useHistory();
    const { onSheet, onIonScroll } = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);

    const [checks, setChecks] = useState<SettlementChecks[]>([]);
    const [lastNum, setLastNum] = useState<number>(0);
    const [showNoPayroll, setShowNoPayroll] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false);

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        ApiService.lpSettlementsGet('settlements', {}).then(it => {
            setChecks(it);
            setLastNum(checks.length);
        }).finally(() => {
            if (!checks?.length) {
                setShowNoPayroll(true);
            }
        });
    }, []);

    const loadMore = () => {
        setLoadingMore(true);
        ApiService.lpSettlementsGet('settlements', {start: lastNum, length: 10}).then(it => {
            setChecks(ch => ch.concat(it));
            setLastNum(checks.length);
        }).finally(() => setLoadingMore(false));
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Money');
    };

    const formatDate = (date: string) => date.substr(5) + '-' + date.substr(0, 4);

    return (
        <IonPage>
            <LoadDetailHeader title="Settlements" onBack={goBack} onSheet={onSheet} />

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero history-hero">
                  <div className="history-hero__eyebrow">Pay</div>
                  <div className="history-hero__title home-display">Settlements</div>
                  <div className="history-hero__meta">
                    {checks.length > 0
                      ? `${checks.length} settlement${checks.length === 1 ? '' : 's'}`
                      : showNoPayroll
                        ? 'No settlements yet'
                        : 'Loading…'}
                  </div>
                </div>

                <div className="home-sheet history-sheet">
                  {checks.length === 0 && showNoPayroll ? (
                    <div className="scoreboard-empty">
                      <strong>No settlement history</strong>
                      <p>Your paid settlements will show up here.</p>
                    </div>
                  ) : null}

                  {checks.length > 0 ? (
                    <section className="history-period">
                      {checks.map(check => (
                        <Link
                          key={check.checknum}
                          to={'/settlements/' + check.checknum}
                          className="history-load"
                        >
                          <div className="history-load__body">
                            <div className="history-load__top">
                              <div className="history-load__number">Settlement #{check.checknum}</div>
                            </div>
                            <div className="history-load__meta">Date {formatDate(check.date)}</div>
                          </div>
                          <ChevronRight />
                        </Link>
                      ))}
                    </section>
                  ) : null}

                  {!showNoPayroll && checks.length > 0 ? (
                    <div className="history-load-more-wrap">
                      <button
                        type="button"
                        className="history-load-more"
                        onClick={loadMore}
                        disabled={loadingMore}
                      >
                        {loadingMore ? 'Loading…' : 'Load more'}
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </IonContent>
        </IonPage>
    );
};

export default Settlements;
